import {
    SEND_EMAIL_CHOICE_ACTIONS,
    SEND_EMAIL_CHOICE_STATUSES,
} from '~/components/SendEmailChoice/constants/sendEmailChoice';
import type { SendEmailChoiceAction, SendEmailChoiceState } from '~/components/SendEmailChoice/types/sendEmailChoice';

export const initialSendEmailChoiceState: SendEmailChoiceState = {
    isMissing: false,
    status: SEND_EMAIL_CHOICE_STATUSES.UNANSWERED,
};

export function sendEmailChoiceReducer(
    state: SendEmailChoiceState,
    action: SendEmailChoiceAction,
): SendEmailChoiceState {
    switch (action.type) {
        case SEND_EMAIL_CHOICE_ACTIONS.CHOSEN:
            return { sendEmail: action.sendEmail, status: SEND_EMAIL_CHOICE_STATUSES.ANSWERED };
        case SEND_EMAIL_CHOICE_ACTIONS.MISSING_ON_SAVE:
            return state.status === SEND_EMAIL_CHOICE_STATUSES.UNANSWERED
                ? { isMissing: true, status: SEND_EMAIL_CHOICE_STATUSES.UNANSWERED }
                : state;
        case SEND_EMAIL_CHOICE_ACTIONS.RESET:
            return initialSendEmailChoiceState;
        default:
            return action satisfies never;
    }
}
